import { render, staticRenderFns } from "./ModalImpossibilidadeRemoverEndereco.vue?vue&type=template&id=60688d9e&scoped=true&"
import script from "./ModalImpossibilidadeRemoverEndereco.vue?vue&type=script&lang=js&"
export * from "./ModalImpossibilidadeRemoverEndereco.vue?vue&type=script&lang=js&"
import style0 from "./ModalImpossibilidadeRemoverEndereco.vue?vue&type=style&index=0&id=60688d9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60688d9e",
  null
  
)

export default component.exports